// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"532":"styles","2143":"app"}[chunkId] || chunkId) + "." + {"532":"511f5304fb63e70763d8","2143":"92dbfec0b00bbe88005c","3373":"3c8f3a1bdb8962228a65"}[chunkId] + ".css";
};